import { render, staticRenderFns } from "./BookmarkModal.vue?vue&type=template&id=67641d27&scoped=true&"
import script from "./BookmarkModal.vue?vue&type=script&lang=js&"
export * from "./BookmarkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67641d27",
  null
  
)

export default component.exports